module.exports = __webpack_public_path__ + "img/defi-pulse.3666b35c.png";